export default "__VITE_ASSET__Bv5yU8Tb__"